const zeros = (n) => new Int32Array(n);
export default zeros;
